export default __webpack_public_path__ + "static/media/background.11896845.jpg";